import React from 'react'
import { motion } from 'framer-motion'
import About from '../components/About'
import SEOMetaTags from '../components/SEOMetaTags'

const AboutPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Majestic Cane Corso Puppies",
    "description": "Professional Cane Corso breeders in Northern California specializing in champion bloodlines, health guaranteed puppies with superior temperament and conformation.",
    "url": "https://norcalcanecorsopuppies.com",
    "telephone": "+1-555-123-4567",
    "email": "info@majesticcorsokennels.com",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "CA",
      "addressCountry": "US",
      "addressLocality": "Northern California"
    },
    "foundingDate": "2008",
    "sameAs": [
      "https://facebook.com/norcalcanecorso",
      "https://instagram.com/norcalcanecorso"
    ],
    "makesOffer": {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Product",
        "name": "Cane Corso Puppies",
        "category": "Pets",
        "brand": "NorCal Cane Corso Puppies"
      }
    },
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "Professional Breeding",
        "recognizedBy": {
          "@type": "Organization",
          "name": "American Kennel Club"
        }
      }
    ]
  }

  return (
    <>
      <SEOMetaTags
        title="About Us - Professional Cane Corso Breeders"
        description="Learn about NorCal Cane Corso Puppies, professional breeders with 15+ years experience. We specialize in champion bloodlines, health guaranteed Cane Corso puppies with superior temperament and professional training foundation."
        keywords="Cane Corso breeders, Northern California, champion bloodlines, professional dog breeding, Italian Mastiff, AKC registered, health guarantee, family socialized puppies"
        canonical="/about"
        ogTitle="About NorCal Cane Corso Puppies - Premium Dog Breeders"
        ogDescription="Discover our passion for breeding exceptional Cane Corso puppies. 15+ years experience, champion bloodlines, health guarantees, and lifetime support for your family companion."
        structuredData={structuredData}
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="page-wrapper"
      >
        <About />
      </motion.div>
    </>
  )
}

export default AboutPage